<template>
  <div class="container-list">
    <div class="flex">
      <!-- <unitList @select="getUnit" @getFirst="getOne"></unitList> -->

      <div class="flex1">
        <div class="common-page common-head">
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            应急预案
          </div>
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div
            class="common-page common-tool-bar"
            style="justify-content: flex-end"
          >
            <div class="flex">
              <el-upload
                action="#"
                accept=".pdf"
                :before-upload="beforeUpHand"
                :http-request="upload"
                :file-list="fileList"
                :limit="10"
              >
                <el-button
                  icon="el-icon-upload"
                  type="success"
                  v-hasPermi="['plan:drillrecord:upload']"
                  >应急预案上传</el-button
                >
              </el-upload>

              <!-- type:  0 只查看  1 可编辑   page:0 演练记录 1 灭火记录  -->

              <div class="ml20">
                <!-- <el-button icon="el-icon-search" type="primary">查询</el-button> -->
                <el-button
                  v-hasPermi="['plan:drillrecord:download']"
                  icon="el-icon-download"
                  type="primary"
                  @click="downLoad"
                  >下载应急预案模板</el-button
                >
              </div>
            </div>
          </div>
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <el-table-column
                prop="yj_name"
                label="应急预案名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="create_time"
                label="上传时间"
                align="center"
              ></el-table-column>

              <!-- <el-table-column
            prop="m_rate"
            align="center"
            label="巡查频次"
          ></el-table-column> -->

              <el-table-column
                label="操作"
                align="center"
                width="200px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="success"
                    v-hasPermi="['plan:drillrecord:yuquery']"
                    @click="showPic(scope.row)"
                    >查看</el-button
                  >

                  <el-popconfirm
                    title="确定删除此单位吗？"
                    class="cursor"
                    @onConfirm="changeStatus(scope.row, 2)"
                    @confirm="changeStatus(scope.row, 2)"
                    v-hasPermi="['plan:drillrecord:yuremove']"
                  >
                    <a slot="reference">
                      <el-button type="danger" size="mini">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <!-- <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      ></fm-generate-form> -->

      <!-- <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">取消</el-button>
      </div> -->
    </el-dialog>
    <el-dialog
      title="查看预案"
      :visible.sync="picDia"
      :close-on-click-modal="false"
      width="90%"
    >
      <iframe
        :src="showUrl"
        frameborder="0"
        style="width: 100%; height: 800px"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import unitList from "@/components/unitList";
import OSS from "ali-oss";

export default {
  data() {
    return {
      list: [],
      params: {
        page: 1,
        companyNum: this.$route.query.c_num,
      },
      picDia: false,
      showUrl: "",
      fileList: [],

      total: 0, // 总数
      showDia: false, // 查询
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    // var name = '/wulianpic/dianzi/files/t1624604744738s2279404/《人员密集场所消防安全管理》GBT 40248-2021.pdf'
    // console.log(`http://zhidui-video.oss-cn-qingdao.aliyuncs.com${name}`)
  },
  mounted() {
    this.getList();
  },
  components: { unitList },
  methods: {
    showPic(it) {
      this.picDia = true;
      this.showUrl = `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${it.yj_url}`;
    },
    downLoad() {
      // var url = 'http://192.168.0.174:8881'
      // var url = 'https://tr.tongren119.com'
      window.open(`${this.$config.apiUrl}/drill/exportyjya`);
    },
    beforeUpHand(file) {
      var isPdf = file.type === "application/pdf";
      if (!isPdf) {
        this.$message.warning("上传报告只支持pdf格式");
        return false;
      }
    },
    upload(val) {
      var upObj = {
        company_num: this.$store.state.user.company.cCompanyNum,
      };
      //   return
      let client = new OSS(this.$bus.config.ossConfig);
      let file = val.file;
      let _this = this;
      let id =
        this.$bus.config.plan +
        "/files" +
        "/t" +
        Date.now() +
        "s" +
        file.size +
        "/" +
        file.name;
      this.$set(this.fileList, id, {
        name: file.name,
        size: file.size,
        uploading: true,
        time: 0,
        progress: 0,
        key: id,
        client: client,
      });
      // _this.getTimes(file, id)

      upObj.yj_name = file.name.substring(0, file.name.lastIndexOf("."));

      // 定义上传方法。
      function multipartUpload() {
        _this.fileList[id].client
          .multipartUpload(id, file, {
            checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
            progress: (p, checkpoint, res) => {
              //log(p,checkpoint,res)
              if (checkpoint) {
                _this.fileList[id].progress = p * 100;
                _this.fileList[id].data = checkpoint;
              }
            },
            partSize: 1000 * 1024, //设置分片大小
            timeout: 120000, //设置超时时间
            mime: val.type,
          })
          .then((res) => {
            _this.fileList[id].progress = 100;
            _this.fileList[id].uploading = false;
            _this.$notify({
              title: "上传成功",
              message: `${_this.fileList[id].name}上传完成`,
              type: "success",
            });

            // _this.nowImage.push(`http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`)
            upObj.yj_url = res.name;
            // 提交请求服务端
            console.log(upObj);
            _this.$post("/drill/yjyaadd", upObj).then((data) => {
              _this.getList();
            });
          })
          .catch((err) => {
            if (
              err.code == "RequestError" ||
              err.code == "ConnectionTimeoutError"
            ) {
              //网络错误或超时
              setTimeout(multipartUpload, 3000);
            }
          });
      }

      multipartUpload();
    },

    handleCheckAllChange(val) {
      this.people = val ? this.groups : [];
    },

    changeStatus(it) {
      this.$post(`drill/yjyadel/${it.uuid}`).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.getList();
      });
    },
    cancle() {
      this.resetSearch();
      this.getList();
      this.showDia = false;
    },

    // 生成二维码
    //  跳转添加

    getList() {
      this.$post("/drill/yjyalist", this.params).then((res) => {
        this.list = res.data.list;
        this.total = res.data.count;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },

    resetSearch() {
      this.params = {
        page: 1,
        companyNum: this.$route.query.c_num,
      };
    },
    // getOne(val) {
    //   this.params.c_company_num = val;
    //   this.getList()
    // },
    // getUnit(val) {
    //   this.params.c_company_num = val;
    //   this.getList()

    // },
  },
  watch: {
    picDia(val) {
      if (!val) {
        this.showUrl = "";
      }
    },
  },
};
</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
</style>
